class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", async (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      const itemVariantId = this.dataset.variantId;
      const matchedItems = removeMatchedBundles(this.dataset.bundleId);
      const lineKeys = matchedItems.map((item) => item.key);
    
      if (matchedItems.length > 1) {
        const variantIds = [];
        const mainItem = matchedItems.find(
          (item) => item.bundleId == item.variantId
        );

        matchedItems.forEach((item) => {
          variantIds.push(item.variantId);
        });
        if (this.dataset.bundleId == itemVariantId) {
          // cartItems.removeItemsByVariantId(this.dataset.index, variantIds);
          cartItems.removeItemsByVariantId(this.dataset.index, lineKeys);
        } else {
          if (matchedItems.length <= 2) {
            cartItems.removeMainItemProps(
              this.dataset.index,
              mainItem.index,
              mainItem.quantity
            );
          } else {
            cartItems.updateQuantity(this.dataset.index, 0, "quantity");
          }
        }
      } else {
        cartItems.updateQuantity(this.dataset.index, 0, "quantity");
      }
    });
  }
}

function removeMatchedBundles(bundleID) {
  if (!bundleID) return [];
  const cartButtons = document.querySelectorAll("cart-remove-button");
  const bundledItems = Array.from(cartButtons)
    .filter((button) => button.dataset.bundleId === bundleID)
    .map((button) => {
    return ({
        bundleId: button.dataset.bundleId,
        variantId: button.dataset.variantId,
        index: button.dataset.index,
        quantity: button.dataset.quantity,
        key: button.dataset.key
    });
});
  return bundledItems;
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.pendingCartUpdates = 0;
  }

  onChange(event) {
    const quantity = parseInt(event.target.value);
    const index = event.target.dataset.index;

    // Remove bundle items if quantity is 0
    if (quantity === 0) {
      const cartItem = event.target.closest(".cart-item");
      const removeButton = cartItem.querySelector("cart-remove-button");

      if (removeButton && removeButton.dataset.bundleId) {
        const matchedItems = removeMatchedBundles(removeButton.dataset.bundleId);
        const lineKeys = matchedItems.map((item) => item.key);
        if (matchedItems.length > 1) {
          const itemVariantId = removeButton.dataset.variantId;
          const mainItem = matchedItems.find(
            (item) => item.bundleId == item.variantId
          );
          if (removeButton.dataset.bundleId == itemVariantId) {
            const variantIds = matchedItems.map((item) => item.variantId);
            // this.removeItemsByVariantId(index, variantIds);
            this.removeItemsByVariantId(index, lineKeys);
          } else if (mainItem) {
            if (matchedItems.length <= 2) {
              this.removeMainItemProps(
                index,
                mainItem.index,
                mainItem.quantity
              );
            } else {
              this.updateQuantity(index, 0, "quantity");
            }
          }
          return;
        }
      }
    }

    const cartItem = event.target.closest(".cart-item");
    const removeButton =
      cartItem && cartItem.querySelector("cart-remove-button");
    if (removeButton && removeButton.dataset.bundleId) {
      const bundleId = removeButton.dataset.bundleId;
      const variantId = removeButton.dataset.variantId;
      if (bundleId == variantId) {
        this.groupedData = {
          bundleId: bundleId,
          quantity: quantity,
        };
      }
    }

    this.updateQuantity(
      index,
      quantity,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async removeMainItemProps(line, mainItemIndex, mainItemQty) {
    this.enableLoading(line);

    const updatePropsRes = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        line: mainItemIndex,
        quantity: mainItemQty,
        properties: {
          "Bundle ID": "",
        },
      }),
    });

    const removeItemRes = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        line: line,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    const updatedCart = await removeItemRes.text();
    this.renderAfterCart(updatedCart, line, "quantity");
    return updatedCart;
  }

  async removeItemsByVariantId(line, lineKeys = []) {
    try {
      const updates = lineKeys.reduce((acc, line) => {
        acc[line] = 0;
        return acc;
      }, {});


      this.enableLoading(line);

      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        }),
      });

      if (!updateResponse.ok) {
        throw new Error(`Failed to update cart: ${updateResponse.status}`);
      }

      const updatedCart = await updateResponse.text();
      this.renderAfterCart(updatedCart, line, "quantity");
      return updatedCart;
    } catch (error) {
      console.error("Error in removeItemsByVariantId:", error);
      throw error;
    }
  }

  async updateQuantity(line, quantity, name) {
    this.pendingCartUpdates = (this.pendingCartUpdates || 0) + 1;
    this.setCheckoutDisabled(true);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderAfterCart(state, line, name);
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  renderAfterCart(state, line, name) {
    const parsedState = JSON.parse(state);
    this.classList.toggle("is-empty", parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector("cart-drawer");
    const cartFooter = document.getElementById("main-cart-footer");

    if (cartFooter)
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    if (cartDrawerWrapper)
      cartDrawerWrapper.classList.toggle(
        "is-empty",
        parsedState.item_count === 0
      );

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    this.applyCheckoutDisabled();

    this.updateLiveRegions(line, parsedState.item_count);
    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(
            cartDrawerWrapper,
            lineItem.querySelector(`[name="${name}"]`)
          )
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(
        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
        cartDrawerWrapper.querySelector("a")
      );
    } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
    }
    this.disableLoading();
    refreshFsLightbox();
    hide_addon_tab();
    initCountdown();

    if (this.groupedData && this.groupedData.bundleId) {
      const { bundleId, quantity } = this.groupedData;

      const buttons = Array.from(
        document.querySelectorAll("cart-remove-button")
      );

      const ribbonButtons = buttons.filter((btn) => {
        const lineIndex = btn.dataset.index;
        const qtyInput = 
          document.getElementById(`Drawer-quantity-${lineIndex}`) || 
          document.getElementById(`Quantity-${lineIndex}`);
        const quantityEl = qtyInput && qtyInput.closest(".cart-item__quantity");
        const isRibbon = !!(
          quantityEl && quantityEl.querySelector(".quantity.custom-ribbon")
        );
        return (
          btn.dataset.bundleId === bundleId &&
          btn.dataset.variantId !== bundleId &&
          isRibbon
        );
      });

      ribbonButtons.forEach((btn) => {
        const ribbonLineIndex = btn.dataset.index;
        const input = 
        document.getElementById(`Drawer-quantity-${ribbonLineIndex}`) || 
        document.getElementById(`Quantity-${ribbonLineIndex}`);
        const currentQty = input ? parseInt(input.value) : null;
        if (currentQty === null || currentQty !== quantity) {
          this.updateQuantity(ribbonLineIndex, quantity, "quantity");
        }
      });
      this.groupedData = null;
    }

    this.pendingCartUpdates = Math.max((this.pendingCartUpdates || 1) - 1, 0);
    
    if (this.pendingCartUpdates === 0) {
      this.setCheckoutDisabled(false);
    }

    // Dispatch custom cart events for external listeners
    if (parsedState.item_count === 0) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: { itemCount: 0 } })
      );
    } else {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { itemCount: parsedState.item_count },
        })
      );
    }
  }

  updateLiveRegions(line, itemCount) {
    //window.location.reload();
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }

  setCheckoutDisabled(disabled) {
    try {
      window.checkoutDisabled = !!disabled;
      const buttons = document.querySelectorAll('button[name="checkout"]');
      buttons.forEach((btn) => {
        if (disabled) {
          btn.setAttribute("disabled", "");
        } else {
          btn.removeAttribute("disabled");
        }
      });
    } catch (e) {}
  }

  applyCheckoutDisabled() {
    try {
      if (window.checkoutDisabled) {
        const buttons = document.querySelectorAll('button[name="checkout"]');
        buttons.forEach((btn) => btn.setAttribute("disabled", ""));
      }
    } catch (e) {}
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}
